export default __webpack_public_path__ + "static/media/May_2021_Sales_Report.bcee0567.pdf";